import { Component, Host, h, Prop, State, Listen, Watch } from '@stencil/core';
import state from '../../state/cta-price';

@Component({
  tag: 'afs-donation-section',
  styleUrl: 'afs-donation-section.scss',
  shadow: false,
  scoped: true
})

export class AfsDonationSection {
    
    @Prop() backgroundColor : string = "#EEE";
    @Prop() color : string = '#000';
    @Prop() fr : boolean = false;
    @Prop() langHeadlineText : string = this.fr 
                ? "J\'aimerais faire un don supplémentaire à mon organisme de bienfaisance." 
                : "I would like to make an additional donation to my charity.";
    @Prop() langOptionalText : string = this.fr ? '(facultatif)' : '(optional)';

    @State() selectedPricePoint : any = null;

    @Listen('donationSelected')
    donationSelectedHandler(e) {
        this.selectedPricePoint = e.detail;
    }

    @Listen('donationDeselected')
    donationDeselectedHandler() {
        this.selectedPricePoint = null;
    }

    @Watch('selectedPricePoint')
    watchSelectedPricePointHandler(newVal) {
        const customEvent = new CustomEvent('donationUpdateSelection', { detail: newVal });
        window.dispatchEvent(customEvent);

        state.donationSelectedPricePoint = newVal;
    }

    componentDidUpdate() {
        if (state.CTATotalPrice > 0) return;
        
        window.dispatchEvent(new CustomEvent('raffleCartEmptied'));
    }    

	render() {
		return (
			<Host style={{
                display: state.donationsVisible ? 'block' : 'none', 
                borderRadius: '0.3rem',
                backgroundColor: this.backgroundColor
            }}>
                <div id='donation-section-wrapper'>
                    <h3 style={{ color: this.color }}>
                        {this.langHeadlineText}
                        <span>{this.langOptionalText}</span>
                    </h3>
                    <div class='price-point-wrapper'>
                        <slot></slot>
                    </div>
                </div>
			</Host>
		)
	}

}